import React from 'react'
import { Grid, Chip } from '@enterprise-ui/canvas-ui-react'

interface AiKeywordsChipsProps {
  andKeywords: string[]
  orKeywords: string[]
  setAiAndOrKeywords: (keywords: { andKeywords: string[]; orKeywords: string[] }) => void
  setIsExactSearchOrSelfAssetToggle: (val: boolean) => void
  setChipsChanged: (val: boolean) => void
}

const AiKeywordsChips: React.FC<AiKeywordsChipsProps> = ({
  andKeywords = [],
  orKeywords = [],
  setAiAndOrKeywords,
  setIsExactSearchOrSelfAssetToggle,
  setChipsChanged,
}) => (
  <Grid.Container>
    {andKeywords?.length > 0 && (
      <Grid.Item xs={6}>
        <Grid.Container className="hc-pl-normal">
          <Grid.Item className="hc-pb-none ai-keywords-headings">
            <strong>Required :</strong>
          </Grid.Item>
          <Grid.Item xs={9} className="hc-pa-none">
            {andKeywords.map((keyword, idx) => (
              <Chip
                key={`${keyword}-${idx}`}
                className={`hc-mr-dense${idx !== 0 ? ' hc-pl-none' : ''} ai-chip-light`}
                removable
                size="dense"
                onRequestDelete={() => {
                  const newVals = andKeywords.filter((_, keyIdx) => keyIdx !== idx)
                  setAiAndOrKeywords({ andKeywords: newVals, orKeywords })
                  setIsExactSearchOrSelfAssetToggle(true)
                  setChipsChanged(true)
                }}
              >
                {keyword}
              </Chip>
            ))}
          </Grid.Item>
        </Grid.Container>
      </Grid.Item>
    )}
    {orKeywords?.length > 0 && (
      <Grid.Item xs={6}>
        <Grid.Container className="hc-pl-normal">
          <Grid.Item className="hc-pb-none ai-keywords-headings">
            <strong>Optional :</strong>
          </Grid.Item>
          <Grid.Item xs={10} className="hc-pa-none">
            {orKeywords.map((keyword, idx) => (
              <Chip
                key={`${keyword}-${idx}`}
                className={`hc-mr-dense${idx !== 0 ? ' hc-pl-none' : ''} ai-chip-dark`}
                removable
                size="dense"
                onRequestDelete={() => {
                  const newVals = orKeywords.filter((_, keyIdx) => keyIdx !== idx)
                  setAiAndOrKeywords({ andKeywords, orKeywords: newVals })
                  setIsExactSearchOrSelfAssetToggle(true)
                  setChipsChanged(true)
                }}
              >
                {keyword}
              </Chip>
            ))}
          </Grid.Item>
        </Grid.Container>
      </Grid.Item>
    )}
  </Grid.Container>
)

export default AiKeywordsChips
